import { ControlsPlay, Tick } from '@berlitz/icons'
import Circle from '@berlitz/streamline-icons/lib/bold/48-Maps-Navigation/04-Sign-Shapes/SignBadgeCircleAlternate'
import NavPin from '@berlitz/streamline-icons/lib/bold/48-Maps-Navigation/05-Pins/Pin'
import AttachmentIcon from '@berlitz/streamline-icons/lib/regular/01-Interface-Essential/27-Link-Unlink/Attachment'
import { ChapterProp } from '@layouts/LearningPath/Chapter/interface'
import { Icon, VideoIcon } from '@layouts/LearningPath/Chapter/style'
import { LP_STATUS } from '@utils/constants/learningPath'
import React from 'react'

const ContentIcon: React.FC<ChapterProp> = ({ Unit, setPlayVideo }) => {
  // No data from API
  const video = ''
  return (
    <Icon>
      {Unit.Status === LP_STATUS.COMPLETE && <Tick color="brand01" size="sm" />}
      {Unit.Status === LP_STATUS.IN_PROGRESS && <NavPin color="brand01" size="sm" />}
      {(Unit.Status === LP_STATUS.NOT_YET_STARTED || !Unit.Status) && <Circle color="brand03" size="sm" />}
      {Unit.IsCourseMetaData && <AttachmentIcon color="brand03" size="sm" />}
      {video && (
        <VideoIcon onClick={() => setPlayVideo!(video)}>
          <ControlsPlay color="brand03" size="sm" />
        </VideoIcon>
      )}
    </Icon>
  )
}

export default ContentIcon
